import { authApi } from '@/api';
import { AuthResponse, LoginCredentials, RegisterData, User } from '../domain';

/**
 * Servicio de autenticación que actúa como capa intermedia entre los componentes
 * y la capa de API, permitiendo una mejor separación de responsabilidades.
 */
export class AuthService {
  // ✅ Inicia sesión unificado (usuarios y admin)
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return authApi.login(credentials);
  }

  // Registra un nuevo usuario en el sistema
  async register(userData: RegisterData): Promise<AuthResponse> {
    return authApi.register(userData);
  }

  // Obtiene el perfil del usuario autenticado
  async getProfile(token: string): Promise<User> {
    return authApi.getProfile();
  }

  // Renueva el token de acceso usando el refresh token
  async refreshToken(): Promise<{ access_token: string; refresh_token?: string }> {
    return authApi.refreshToken();
  }

  // Cierra la sesión del usuario actual
  async logout(token?: string): Promise<void> {
    if (token) {
      await authApi.logout();
    } else {
      await authApi.logout();
    }
  }

  // Solicita el restablecimiento de contraseña
  async requestPasswordReset(email: string): Promise<void> {
    await authApi.requestPasswordReset(email);
  }

  // Restablece la contraseña usando un token de restablecimiento
  async resetPassword(newPassword: string, token?: string): Promise<void> {
    await authApi.resetPassword(newPassword, token);
  }

  // Inicia el flujo de autenticación con Google
  async signInWithGoogle(): Promise<AuthResponse> {
    return authApi.signInWithGoogle();
  }

  // Actualiza la información del perfil del usuario
  async updateProfile(userData: Partial<User>, token: string): Promise<User> {
    return authApi.updateProfile(userData);
  }
}

// Instancia única del servicio de autenticación
export const authService = new AuthService();
